export const APPID = 'wx672b61314f2b449b'
// export const APPID = '2018011801952052'
export const SHAREURL = 'https://collecth5.apicall.id-photo-verify.com/joinTeam'
// export const SHAREURL = 'https://test.zhgroot.cn/joinTeam'
export const BASEURL = 'https://apicall.id-photo-verify.com'
export const TESTURL = 'http://nyasu.leqi.us:8976/collect_pic/upload_pic'
